import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';

const Content = styled.div`
    margin-top: ${Spacing8};
`;

export default Content;
